var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTutorialPhotosIcon = function SvgTutorialPhotosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu/ Photos")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu/-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    cx: 14,
    cy: 16,
    r: 4.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    cx: 23,
    cy: 11.5,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    cx: 14,
    cy: 16,
    r: 6.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,6 L16.5,6",
    id: "Path-5",
    stroke: "#B2B2B2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375,3 L20.979,8 L24.5,8 C25.6045695,8 26.5,8.8954305 26.5,10 L26.5,23 C26.5,24.1045695 25.6045695,25 24.5,25 L3.5,25 C2.3954305,25 1.5,24.1045695 1.5,23 L1.5,10 C1.5,8.8954305 2.3954305,8 3.5,8 L7.02,7.999 L9.625,3 L18.375,3 Z",
    id: "Combined-Shape",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }))));
};

export default __webpack_public_path__ + "static/media/tutorial-photos-icon.3804f2b7.svg";
export { SvgTutorialPhotosIcon as ReactComponent };